import { render, staticRenderFns } from "./BridgeManagement.vue?vue&type=template&id=6d17e13d&scoped=true"
import script from "./BridgeManagement.vue?vue&type=script&lang=js"
export * from "./BridgeManagement.vue?vue&type=script&lang=js"
import style0 from "./BridgeManagement.vue?vue&type=style&index=0&id=6d17e13d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d17e13d",
  null
  
)

export default component.exports